import React from 'react'
import { Dashboard } from './containers/Dashboard'


function App(): JSX.Element {
  return (
    <>
      <main>
        <Dashboard  />
      </main>
    </>
  )
}

export default App
